import {
  termTemplatesIdProps,
  listTermTemplatesProps,
  PostTermTemplatesProps,
} from "../types/termTemplates";
import { getHotelId, headers, querystring, request } from "./lib/common";

export const selectTermTemplates = ({ id }: termTemplatesIdProps) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/terms_templates/${id}`,
    headers({}),
  );
};

export const listTermTemplate = ({
  hotel_id,
  title,
  offset,
  limit,
  pagination = true,
}: listTermTemplatesProps) => {
  return request.get(
    `/multifamily/hotels/${hotel_id ? hotel_id : getHotelId()}/terms_templates`,
    {
      ...querystring({
        ...(title && { title }),
        offset,
        limit,
        pagination,
      }),
      ...headers({}),
    },
  );
};

export const createTermTemplate = ({
  title,
  content,
  language,
}: PostTermTemplatesProps) => {
  const data = {
    title,
    content,
    language,
    is_published: false,
  };

  return request.post(
    `/multifamily/hotels/${getHotelId()}/terms_templates`,
    data,
    headers({}),
  );
};

export const updateTermTemplate = ({
  id,
  title,
  content,
  language,
  is_published,
}: PostTermTemplatesProps) => {
  const data = {
    title,
    content,
    language,
    is_published,
  };

  return request.put(
    `/multifamily/hotels/${getHotelId()}/terms_templates/${id}`,
    data,
    headers({}),
  );
};

export const deleteTermTemplate = ({ id }: termTemplatesIdProps) => {
  return request.delete(
    `/multifamily/hotels/${getHotelId()}/terms_templates/${id}`,
    headers({}),
  );
};

// listBuilding, selectBuilding API 호출 값
export type listTermTemplateApi = {
  id: string;
  hotel_id: string;
  title: string;
  content: string;
  language: string;
  is_published: boolean;
  created_at: Date;
  updated_at: Date;
};
